import { GridFooterCellProps } from '@progress/kendo-react-grid';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { getIcon } from 'src/utils/icons';

const WarningFooterCell = (props: GridFooterCellProps) => {
  const { errorMessageList, footerInfoMessage } = useViewBudgetPeriod();
  return (
    <td className="overflow-visible-imp">
      <PopUp
        popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'center' }}
        content={
          <div className="m-1 max-w-[350px]">
            <PopUpContentWrapper type="Error" contents={errorMessageList} />
            <PopUpContentWrapper type="Information" contents={footerInfoMessage} />
          </div>
        }
      >
        <div className="flex justify-center items-center">
          {getIcon(errorMessageList, [], footerInfoMessage)}
        </div>
      </PopUp>
    </td>
  );
};

export default WarningFooterCell;
